import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import icon from '../utility/images/iconWhite.svg';
import text from '../utility/images/textWhite.svg';
import { primaryColor, primaryColorBlue } from '../utility/constant';
import { heroGradient } from '../components/faq';
export default function Navbar({ isShowShadow }) {
  const [hasScrolled, setHasScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  // #ffc40c
  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { name: 'Home', path: '/landing' },
    { name: 'Terms & Conditions', path: '/terms_conditions' },
    // { name: 'Contact Us', path: '/contact' },
    { name: 'Sign Up', path: '/auth/signup' },
    { name: 'Login', path: '/auth/login' },
  ];

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeInOut' }}
      style={
        hasScrolled || isShowShadow
          ? {
              zIndex: 1000,

              background: `linear-gradient(250deg, ${primaryColorBlue} 0%, ${primaryColor} 30%)`,
            }
          : {
              zIndex: 1000,

              backgroundColor: 'transparent',
            }
      }
      className={`fixed  left-0 right-0 pb-6 pt-6  flex items-center justify-between transition-shadow ${
        hasScrolled || isShowShadow ? 'shadow-md ' : ''
      }`}
    >
      <div className="flex  justify-between  items-center mx-auto  container">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          onClick={() => navigate('/landing')}
          className="cursor-pointer flex items-center"
        >
          <img src={icon} height={30} className="" alt="Logo Icon" />
          <img src={text} className="h-[30px] ml-2" alt="Logo Text" />
        </motion.div>

        {/* Desktop Menu */}
        {/* Desktop Menu */}
        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-4">
          {menuItems.map((item) => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`px-5 py-2 rounded-full font-medium transition-all duration-300 shadow-md border ${
                location.pathname === item.path
                  ? 'bg-[#4d5be5] text-white border-[#4d5be5] shadow-lg'
                  : 'text-white border-white/20 hover:bg-white/10 hover:border-white hover:shadow-lg'
              }`}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.97 }}
            >
              {item.name}
            </button>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={28} /> : <Menu size={28} color="white" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {/* Mobile Menu */}
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-[#0d0d0d] flex flex-col p-5 md:hidden z-40">
          {menuItems.map((item) => (
            <button
              key={item.path}
              onClick={() => {
                navigate(item.path);
                setIsMenuOpen(false);
              }}
              className={`py-3 text-lg text-left font-medium transition-all duration-300 border-b border-gray-700 rounded-md shadow-sm ${
                location.pathname === item.path
                  ? 'text-[#4d5be5] shadow-md'
                  : 'text-gray-200 hover:text-white hover:shadow-md'
              }`}
            >
              {item.name}
            </button>
          ))}
        </div>
      )}
    </motion.header>
  );
}
